import { render, staticRenderFns } from "./ManualReturnModal.vue?vue&type=template&id=45f31eec"
import script from "./ManualReturnModal.vue?vue&type=script&lang=js"
export * from "./ManualReturnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports